import Paper from '@mui/material/Paper';

import {  styled } from '@mui/material/styles';

export const Container = styled(Paper)(() => ({
  height: "100%",
  padding: 16,
  display: 'flex',
  alignItems: 'canter',
  flexDirection: 'column',
  rowGap: 6,

  '> strong': {
    fontSize: '1.25rem',
  },
}));
